module.exports = __webpack_public_path__ + "img/CoreBank-Logo-1.913f70de.png";